import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { Hooks } from '@grandvisionhq/payments';
import { useCartStorage } from '../../../hooks/use-cart-storage.js';
import { REMOVE_CART_LINE_ITEMS } from '../../../operations/mutations/remove-cart-line-items.js';
import { GET_CART } from '../../../operations/queries/get-cart.js';

// This component returns the regular "go to checkout" button if there are no
// unavailable line items. If there are unavailable line items, it removes
// them from the cart before navigating to checkout.
const FixCartButtonContainer = ({ unavailableLineItems , labels  })=>{
    const [{ cartId  }, { setCartCount  }] = useCartStorage();
    const { href: hrefWithCartId  } = Hooks.useGoToCheckoutLink(cartId);
    const unavailableItemIds = unavailableLineItems === null || unavailableLineItems === void 0 ? void 0 : unavailableLineItems.map(({ id  })=>({
            id
        })
    );
    const hasUnavailableItems = unavailableItemIds === null || unavailableItemIds === void 0 ? void 0 : unavailableItemIds.length;
    const [removeCartItems, { loading  }] = useMutation(REMOVE_CART_LINE_ITEMS, {
        onCompleted: (data)=>{
            var ref;
            // If no line items are left, we don't want to navigate to checkout
            if (!((ref = data.removeCartLineItems.cart) === null || ref === void 0 ? void 0 : ref.lineItems.length)) {
                return;
            }
            // @TODO useLink is not applying query params properly so we are navigating
            // manually for now until fix arrives
            window.location.href = hrefWithCartId;
        },
        update (cache, { data  }) {
            if (data && data.removeCartLineItems.success === true) {
                const newCart = data.removeCartLineItems.cart;
                cache.writeQuery({
                    query: GET_CART,
                    variables: {
                        id: cartId
                    },
                    data: {
                        getCart: {
                            cart: newCart
                        }
                    }
                });
                setCartCount((newCart === null || newCart === void 0 ? void 0 : newCart.numberOfItems) || 0);
                window.scrollTo(0, 0);
            }
        }
    });
    const removeAndNavigate = React.useCallback((e)=>{
        if (hasUnavailableItems && cartId) {
            e.preventDefault();
            removeCartItems({
                variables: {
                    cartInput: {
                        cartId,
                        lineItems: unavailableItemIds
                    }
                }
            });
        }
    }, [
        removeCartItems,
        cartId,
        unavailableItemIds,
        hasUnavailableItems
    ]);
    return /*#__PURE__*/ React.createElement(Button, {
        isLoading: loading,
        className: "cart-navigation__button",
        "data-t": "cart-go-to-checkout",
        caption: labels.goToCheckout,
        href: hrefWithCartId,
        onClick: hasUnavailableItems ? removeAndNavigate : undefined
    });
};

export { FixCartButtonContainer };
//# sourceMappingURL=FixCartButtonContainer.js.map
